/**
 * Centralized Chat Service
 * This service manages the LiveChat widget functionality across the entire website.
 * The LiveChat script is loaded from /assets/js/chat-script.js
 */

let chatInitialized = false;

/**
 * Initialize the chat widget
 * This function will be called once when the app loads
 */
export const initializeChat = () => {
  if (chatInitialized) {
    return;
  }

  const checkInterval = setInterval(() => {
    if (window.LiveChatWidget) {
      chatInitialized = true;
      clearInterval(checkInterval);
    }
  }, 100);

  setTimeout(() => clearInterval(checkInterval), 10000);
};

/**
 * Open the chat widget
 * This function is called when any "Chat Now" button is clicked
 */
export const openChat = () => {
  if (window.LiveChatWidget) {
    window.LiveChatWidget.call('maximize');
  } else {
    setTimeout(() => {
      if (window.LiveChatWidget) {
        window.LiveChatWidget.call('maximize');
      }
    }, 1000);
  }
};

/**
 * Close the chat widget
 */
export const closeChat = () => {
  if (window.LiveChatWidget) {
    window.LiveChatWidget.call('minimize');
  }
};

/**
 * Check if chat is available
 */
export const isChatAvailable = () => {
  return chatInitialized && !!window.LiveChatWidget;
};
